import { useHasRole } from './use-has-role';

export const JOB_ARCHITECTURE_ROLES: readonly string[] = ['job_architect', 'reviewer', 'viewer'];

export const useHasJobArchitectureRole = (): boolean => useHasRole(...JOB_ARCHITECTURE_ROLES);
